export function getEntityType(entityType: string) {
    switch (entityType) {
        case "stream:feeds:v2:activity":
            return "Activity";
        case "stream:feeds:v2:reaction":
            return "Reaction";
        case "stream:chat:v1:message":
            return "Message";
        case "stream:user":
            return "User";
        default:
            return "Unknown";
    }
}